import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const mfile = new Restful(project, 'mfile')

mfile.history = function(data) {
  const url = project + 'mfile/history'
  return http.get(url, data).then(res => {
    return res
  })
}

mfile.manuscript = function(data) {
  const url = project + 'mfile/manuscript'
  return http.put(url, data).then(res => {
    return res
  })
}

mfile.reviewer = function(data) {
  const url = project + 'mfile/reviewer'
  return http.post(url, data).then(res => {
    return res
  })
}

mfile.allHistory = function(id, data) {
  const url = project + `mfile/all/history/${id}`
  return http.get(url, data).then(res => {
    return res
  })
}
export default mfile
